import { jsxs as $, Fragment as T, jsx as t } from "react/jsx-runtime";
import { u as i } from "./index-6a632112.mjs";
import { e as r, h as f, i as w, c as h, b as c, Q as d, s as u, d as S, a as W } from "./themes-5f0b3c3d.mjs";
import p from "react";
import { h as b } from "./hTag-40b23797.mjs";
import { Button as k } from "./button.js";
import { Link as z } from "./link.js";
import { f as A } from "./fontWeights-a25f8f91.mjs";
import { l as E } from "./lineHeights-72d3110c.mjs";
import { C as V } from "./ChildrenCountCheck-60cafda6.mjs";
import { Disclosures as D } from "./disclosure.js";
import "./textStyles-42cab346.mjs";
import "./accessibility.js";
const I = () => ` 
  margin-block-start: unset;
  margin-block-end: unset;
  margin-inline-start: unset;
  margin-inline-end: unset;`, x = i(b)`
  color: ${({ theme: e }) => e.components.globalAttributeBar.titleTextColor};
  font-family: ${r.medium.S.fontFamily};
  font-size: ${r.medium.S.fontSize};
  font-weight: ${r.medium.S.fontWeight};
  line-height: ${r.medium.S.lineHeight};
`, y = i(b)`
  color: ${({ theme: e }) => e.components.globalAttributeBar.valueTextColor};
  font-family: ${f.XL.fontFamily};
  font-size: ${f.XL.fontSize};
  font-weight: ${f.XL.fontWeight};
  line-height: ${f.XL.lineHeight};
`, L = i.p`
  ${I()}
  color: ${w.subtle};
  font-family: ${r.regular.S.fontFamily};
  font-size: ${r.regular.S.fontSize};
  font-weight: ${r.regular.S.fontWeight};
  line-height: ${r.regular.S.lineHeight};
`, v = 5, B = i.div`
  background-color: ${h.brandTwilight[0]};
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border: ${c["1x"]} solid ${h.brandTwilight[400]};

  @media ${d.laptopAndUp} {
    flex-direction: row;
    min-height: 172px;
  }
  @media${d.desktopAndUp} {
    min-height: 188px;
  }
`, U = i.div`
  padding: ${u["8x"]};
  display: flex;
  align-items: ${({ $enableButton: e }) => e ? "center" : "flex-start"};
  justify-content: ${({ $enableButton: e }) => e ? "center" : "flex-start"};

  flex-direction: column;
  &:not(:first-child) {
    border-top: ${c["1x"]} solid ${h.brandTwilight[400]};
  }
  word-break: break-word;
  @media ${d.laptopAndUp} {
    width: 100%;
    padding: ${u["6x"]};

    &:not(:first-child) {
      border-top: unset;
      border-left: ${c["1x"]} solid ${h.brandTwilight[400]};
    }
  }
  @media ${d.desktopAndUp} {
    padding: ${u["8x"]};
  }
`, C = i.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: ${u["2x"]};
  width: 100%;
  && > a {
    font-family: ${S.eyebrow};
    font-size: ${W.xsmall};
    font-weight: ${A.eyebrow};
    line-height: ${E.small};
  }
`, H = i(C)`
  @media ${d.laptopAndUp} {
    gap: unset;
  }
`, R = ({ children: e }) => /* @__PURE__ */ $(T, { children: [
  /* @__PURE__ */ t(
    V,
    {
      children: e,
      componentName: "GlobalAttributeBar",
      maxChildren: v
    }
  ),
  /* @__PURE__ */ t(B, { children: (() => p.Children.map(e, (o, g) => o && p.isValidElement(o) && o.type === s ? p.cloneElement(o, {
    key: g
  }) : null))() })
] }), s = ({
  children: e,
  enableButton: n,
  onClick: o,
  buttonLabel: g = "Button",
  disclosures: a
}) => {
  const m = {
    titleOrValueContainer: [],
    otherElement: []
  };
  return p.Children.forEach(e, (l) => {
    l && p.isValidElement(l) && (l.type === x || l.type === y) ? m.titleOrValueContainer.push(l) : m.otherElement.push(l);
  }), /* @__PURE__ */ t(U, { $enableButton: n, children: n ? /* @__PURE__ */ t(k, { size: "small", variant: "solid", onClick: o, children: g }) : /* @__PURE__ */ $(C, { children: [
    m.titleOrValueContainer.length > 0 && /* @__PURE__ */ t(H, { children: m.titleOrValueContainer }),
    m.otherElement,
    a && /* @__PURE__ */ t(
      D,
      {
        disclosureContent: a?.disclosureContent,
        id: a?.id,
        className: a?.className,
        disclosureTitleColor: a?.disclosureTitleColor,
        style: a?.style
      }
    )
  ] }) });
}, X = ({ children: e, headingLevel: n = "h1" }) => /* @__PURE__ */ t(x, { as: n, children: e }), F = ({ children: e, headingLevel: n = "h2" }) => /* @__PURE__ */ t(y, { as: n, children: e });
R.ItemContainer = s;
s.Title = X;
s.Description = L;
s.Value = F;
s.Link = z;
export {
  R as GlobalAttributeBar
};
